module.exports = __webpack_public_path__ + "img/20190619163430900.a433a5b2.png";